import { render } from "./PreferencesModal.vue?vue&type=template&id=b9b42440&scoped=true"
import script from "./PreferencesModal.vue?vue&type=script&lang=js"
export * from "./PreferencesModal.vue?vue&type=script&lang=js"

import "./PreferencesModal.vue?vue&type=style&index=0&id=b9b42440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b42440"]])

export default __exports__